module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded === 'true') ? _c('ul', {
    staticClass: "radio-opciones"
  }, [_c('li', {
    staticClass: "streamsaudio"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.loadedstreams === 'true') ? _c('ul', {
    attrs: {
      "id": "lista_streams"
    }
  }, _vm._l((_vm.streams), function(stream) {
    return _c('li', [_c('a', {
      staticClass: "obj-cont",
      attrs: {
        "href": "#",
        "stream_url": stream.stream_url,
        "stream_title": stream.title.rendered
      }
    }, [(stream.better_featured_image.media_details.sizes.thumbnail.source_url !== null) ? _c('img', {
      staticClass: "obj-img",
      attrs: {
        "src": stream.better_featured_image.media_details.sizes.thumbnail.source_url,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "obj-img",
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })])])
  })) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "actual"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programa',
        params: {
          elprograma: _vm.programas.actual.post_name
        }
      }
    }
  }, [(_vm.programas.actual.meta.images['50x50'] !== null) ? _c('figure', {
    staticClass: "obj-cont actual__img"
  }, [_c('img', {
    staticClass: "obj-img",
    attrs: {
      "src": _vm.programas.actual.meta.images['50x50']
    }
  })]) : _c('figure', {
    staticClass: "obj-cont actual__img"
  }, [_c('img', {
    staticClass: "obj-img",
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/novedad.jpg'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actual__desc"
  }, [_c('h3', [_vm._v("Programa Actual")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.programas.actual.post_title))])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "proximamente"
  }, [_vm._m(2), _vm._v(" "), _c('ul', [_vm._l((_vm.programas.proximos), function(programa) {
    return _c('li', [_c('router-link', {
      staticClass: "obj-cont",
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: programa.post_name
          }
        }
      }
    }, [(programa.meta.images['805x773'] !== null) ? _c('img', {
      staticClass: "obj-img",
      attrs: {
        "src": programa.meta.images['805x773'],
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "obj-img",
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })])], 1)
  }), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "obj-cont",
    attrs: {
      "to": {
        name: 'programas'
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVER PROGRAMACION COMPLETA\n\t\t\t\t")])], 1)], 2)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "online paused"
  }, [_c('div', {
    staticClass: "btn gradient"
  }, [_c('i', {
    staticClass: "icon icon-radio"
  })]), _vm._v(" "), _c('span', [_vm._v("Radio Online")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Proximamente "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39cfd851"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proximosprogramas.vue
// module id = 126
// module chunks = 0